'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require('revalidate');

var _emailValidator = require('email-validator');

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var validate = (0, _revalidate.combineValidators)({
  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)('Email'),

  password: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1))('Password')
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/signupFormValidation.js
// module id = 2914
// module chunks = 0